export default {
  user: undefined,
  tempFirstname: null,
  tempLastname: null
}
